module.exports = __webpack_public_path__ + "static/img/wisg.b46348d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wisg.png
// module id = dmTa
// module chunks = 1